import './index.scss'
import React from 'react'
import Content from '../../../components/content'
import Editable from "../../../components/editable/index";

// 我们的团队
const Partners = (props) => {
  //
  return [{
    uid: 'partners-1',
    html:(
      <div className="section-partners">
        <div className="container">
          <Content { ...props.title } className="section-title text-center" />
          <div>
            {props.list.items.map((item, index) =>
              <div className="col-sm-2 col-xs-4" key={'list-item' + index}>
                <div className="partner-wrap">
                  <Content {...item.media} className="partner-logo" />
                  <Editable {...item.title}>
                    <div className="partner-name text-muted">{item.title.content}</div>
                  </Editable>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }]
}

export default Partners


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/partners/index.js